module.exports = __webpack_public_path__ + "img/宋志娜讲师.7bd80867.png";